import { BaseClass } from '../base/BaseClass';

export class Accordion extends BaseClass {
  /**
   * Accordion expansion class name
   *
   * @type {string}
   */
  expansionClass = 'accordion__expanded';

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * Controls the carousels of the website.
   * Uses library swiperjs: https://swiperjs.com/
   *
   */
  constructor(identifier, multi) {
    super(identifier, multi);
    if (this.targetExists()) {
      this.init();
    }
  }

  /**
   * Initialise the accordions and add click listeners.
   */
  init = () => {
    this.target.forEach((accordion) => {
      const header = accordion.querySelector('.accordion__heading-wrapper');
      header.addEventListener('click', () => {
        const content = accordion.querySelector('.accordion__content-wrapper');
        const contentHeight = content.scrollHeight;
        accordion.classList.toggle(this.expansionClass);
        content.style.height = accordion.classList.contains(this.expansionClass)
          ? `${contentHeight}px`
          : '0px';
      });
    });
  };
}
